import { jsxs, jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
const SvgStudent = (props, ref) => /* @__PURE__ */ jsxs("svg", { viewBox: "0 0 188 165", xmlns: "http://www.w3.org/2000/svg", ref, ...props, children: [
  /* @__PURE__ */ jsxs("defs", { children: [
    /* @__PURE__ */ jsxs("linearGradient", { x1: "-29.897%", y1: "44.13%", x2: "69.824%", y2: "50.786%", id: "Student_svg__a", children: [
      /* @__PURE__ */ jsx("stop", { stopColor: "#FFBEB6", offset: "0%" }),
      /* @__PURE__ */ jsx("stop", { stopColor: "#F2A19C", offset: "100%" })
    ] }),
    /* @__PURE__ */ jsxs("linearGradient", { x1: "19.555%", y1: "49.83%", x2: "104.727%", y2: "50.444%", id: "Student_svg__b", children: [
      /* @__PURE__ */ jsx("stop", { stopColor: "#FFBEB6", offset: "0%" }),
      /* @__PURE__ */ jsx("stop", { stopColor: "#F2A19C", offset: "100%" })
    ] }),
    /* @__PURE__ */ jsxs("linearGradient", { x1: "37.136%", y1: "50.073%", x2: "87.531%", y2: "49.831%", id: "Student_svg__c", children: [
      /* @__PURE__ */ jsx("stop", { stopColor: "#FFBEB6", offset: "0%" }),
      /* @__PURE__ */ jsx("stop", { stopColor: "#F2A19C", offset: "100%" })
    ] }),
    /* @__PURE__ */ jsxs("linearGradient", { x1: "50.957%", y1: "56.197%", x2: "44.377%", y2: "5.075%", id: "Student_svg__d", children: [
      /* @__PURE__ */ jsx("stop", { stopColor: "#428DFC", offset: "0%" }),
      /* @__PURE__ */ jsx("stop", { stopColor: "#1D72D8", offset: "100%" })
    ] }),
    /* @__PURE__ */ jsxs("linearGradient", { x1: "47.876%", y1: "46.151%", x2: "51.955%", y2: "61.75%", id: "Student_svg__e", children: [
      /* @__PURE__ */ jsx("stop", { stopColor: "#23286B", offset: "0%" }),
      /* @__PURE__ */ jsx("stop", { stopColor: "#151A4F", offset: "100%" })
    ] }),
    /* @__PURE__ */ jsxs("linearGradient", { x1: "76.669%", y1: "42.343%", x2: "4.214%", y2: "82.627%", id: "Student_svg__f", children: [
      /* @__PURE__ */ jsx("stop", { stopColor: "#A1C3FC", offset: "0%" }),
      /* @__PURE__ */ jsx("stop", { stopColor: "#78A9EF", offset: "100%" })
    ] }),
    /* @__PURE__ */ jsxs("linearGradient", { x1: "100.009%", y1: "50.005%", x2: "-.01%", y2: "50.005%", id: "Student_svg__g", children: [
      /* @__PURE__ */ jsx("stop", { stopColor: "#EEE", offset: "0%" }),
      /* @__PURE__ */ jsx("stop", { stopColor: "#D6D7D8", offset: "100%" })
    ] }),
    /* @__PURE__ */ jsxs("linearGradient", { x1: "50.084%", y1: "45.742%", x2: "48.779%", y2: "60.495%", id: "Student_svg__h", children: [
      /* @__PURE__ */ jsx("stop", { stopColor: "#FFBEB6", offset: "0%" }),
      /* @__PURE__ */ jsx("stop", { stopColor: "#F2A19C", offset: "100%" })
    ] })
  ] }),
  /* @__PURE__ */ jsxs("g", { fill: "none", fillRule: "evenodd", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M50.414 39.04c.498-.257.605.775.676 1.226.57 3.128 1.068 6.352 2.492 9.254.284.58.605 1.257.284 1.805-.106.226-.32.387-.498.548-1.815 1.71-3.809 2.934-4.77 5.127-.783-2.193-1.459-3.934-1.85-6.223-.463-2.708-.641-3.482-.748-6.223 0-.516.427-2.547.64-3.03.285-.452 2.848-1.903 3.774-2.483Z",
        fill: "#1D72D8",
        fillRule: "nonzero"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M50.756 47.809c-2.191-.924-4.092-3.09-3.706-5.416.065-.319.161-.67.387-.892.258-.287.645-.382 1.031-.478C54.624 39.239 60.07 35.257 63.615 30A63.508 63.508 0 0 1 66 41.246c-.87 1.083-2.385 1.306-3.738 1.657-3.642.924-6.768 3.185-10.12 4.874-.225.096-.451.223-.677.223a2.584 2.584 0 0 1-.709-.191Z",
        fill: "url(#Student_svg__a)",
        fillRule: "nonzero"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M56.025 36.837c.131-3.473 1.052-7.27 3.912-9.315 1.809-1.299 4.176-1.688 6.38-1.46 2.235.194 4.372.973 6.444 1.752 2.762 1.071 5.787 2.5 6.839 5.258.723 1.85.362 3.928-.263 5.81-1.15 3.441-3.288 6.622-6.214 8.83-.757.583-1.612 1.07-2.467 1.492-.953 1.039-1.348 1.331-2.334 2.435-.92 1.006-1.184-.325-1.545-1.136-1.316.26-2.664.324-3.979.162-1.315-.13-2.663-.52-3.715-1.33-1.48-1.17-2.072-3.117-2.466-4.935-.494-2.499-.691-5.03-.592-7.563Z",
        fill: "url(#Student_svg__b)",
        fillRule: "nonzero"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M48.363 71.157c.696-4.138 2.019-11.921 1.532-16.092-.488-4.171-2.019-4.894-5.5-7.488-1.949-1.478-5.011-2.3-6.856-.723-1.288 1.117-2.82 3.777-2.889 5.419-.974 16.52-4.28 30.937 2.61 48.705 2.158.131 4.351-.328 6.265-1.314.314-.164.627-.36.87-.624.279-.36.383-.82.453-1.28 1.01-5.978 1.357-10.412 2.332-16.356.452-2.956.696-7.324 1.183-10.247Z",
        fill: "#89B3F4",
        fillRule: "nonzero"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M88.727 73.79c-1.422-1.444-11.339-2.117-16.43-1.636-2.215.224-4.496-.192-6.71.224-2.215.417-4.199 1.668-6.083 2.854-3.703 2.372-5.686 7.374-9.388 9.747-1.389.865-4.53 5.61-6.116 5.93.86 2.502 8.661-1.41 9.554 1.091 4.23-5.258 5.553-6.06 10.082-11.061 1.422-1.571 2.48-3.591 4.364-4.585 1.289-.673 2.777-.802 4.231-1.026 5.455-.834 18.843.834 16.496-1.539Z",
        fill: "url(#Student_svg__c)",
        fillRule: "nonzero"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M46.752 97.96c-1.492 1.616-3.016 3.266-4.873 4.495-1.856 1.197-3.745.259-5.602-1.23-1.392-5.077 2.685-8.603 7.16-12.613C47.945 84.6 53.88 80.202 57.26 77c.331 2.232 2.585 4.722 4.74 5.53-5.138 6.308-10.375 10.092-15.248 15.43Z",
        fill: "#89B3F4",
        fillRule: "nonzero"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M150.557 149.414c-4.777-.931-21.71 0-21.71 0s-1.911 9.371-1.845 15.52c7.149 0 14.298.033 21.447.033 12.025 0 14.858.133 27.542-.133.264-2.891-5.403-8.142-15.78-10.635-2.307-.532-7.314-4.353-9.654-4.785Z",
        fill: "#F7931E",
        fillRule: "nonzero"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M162.557 149.414c-4.777-.931-21.71 0-21.71 0s-1.911 9.371-1.845 15.52c7.149 0 14.298.033 21.447.033 12.025 0 14.858.133 27.542-.133.264-2.891-5.403-8.142-15.78-10.635-2.307-.532-7.314-4.353-9.654-4.785Z",
        fill: "#FBB03B",
        fillRule: "nonzero"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M92.055 109.442c-14.243 7.852-25.663 21.083-41.218 25.834-11.683 3.563-24.81 1.716-35.18-4.751-5.35-3.333-10.174-8.183-11.52-14.353-.13-.627-.229-1.253 0-1.847.263-.726.952-1.188 1.609-1.584 5.25-3.3 10.698-6.203 16.343-8.71 2.822.956 3.544 5.18 6.432 5.971 1.674.462 3.38-.428 4.922-1.253 9.878-5.147 49.193-40.418 59.826-32.631 27.402 20.06 42.105 41.638 63.731 73.61-8.63.494-29.24.164-29.24.164s-4.627-3.86-10.14-10.195c-4.726-5.444-3.775-11.977-7.45-13.593-3.643-1.617-10.042-7.622-11.158-11.482-.689-2.343-.952-5.444-3.282-6.071-1.247-.363-2.527.264-3.675.89Z",
        fill: "#151A4F",
        fillRule: "nonzero"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M15.95 67.015c-1.327-.066-2.72.066-3.787.824-.907.626-1.49 1.614-2.008 2.57C2.807 83.656.282 99.605 3.163 114.565c.226 1.153.485 2.373 1.23 3.262.81.989 2.04 1.45 3.237 1.846 3.658 1.12 7.51 1.548 11.298 1.219 2.267-.198 4.76-.824 5.957-2.801 1.198-2.01.55-4.58-.13-6.854-1.877-6.13-3.82-12.39-3.593-18.816.26-6.426 3.173-13.148 8.838-16.015-2.59-5.37-8.19-9.127-14.05-9.391Z",
        fill: "url(#Student_svg__d)",
        fillRule: "nonzero"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M19.803 141.771c3.1 1.253 6.531 1.484 9.863 1.385 11.413-.396 22.662-4.878 31.206-12.426 10.82-9.558 20.452-24.291 34.075-29.004 9.204-2.802 6.07 9.163 15.57 19.15 3.76 3.954 9.27 4.317 12.404 8.074 3.562 4.318 1.154 2.307 4.123 9.558.858 2.11 11.974 11.207 13.36 11.24 9.632.23 12.271.362 22.596.131-9.863-23.203-32.591-46.472-49.547-70.862a7.316 7.316 0 0 0-3.991-2.802c-1.089-.296-2.21-.23-3.332-.132-26.588 2.143-52.482 12.558-73.132 29.433-1.749 1.417-3.464 2.11-4.718 4.35-.923 1.649-.198 4.813.231 7.581.43 2.769.759 4.285-1.913 5.11 1.056-4.912.56-13.02.56-13.02s-3.43-3.955-5.112-6.46C15.382 106.604 7.96 106.9 1 104c0 10.745 2.54 16.348 6.103 23.83 2.837 5.768 6.729 11.535 12.7 13.941Z",
        fill: "url(#Student_svg__e)",
        fillRule: "nonzero"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M49.998 42.006c-1.482-1.984-8.628-.695-11.56.958-10.834 6.15-18.77 12.96-25.786 23.274C10.282 69.71 8.57 72.685 6 79c5.73.364 7.377 8.133 22.987 12.001 2.931-9.984 5.763-15.538 12.449-21.357 5.006-4.363 5.565-5.355 7.706-13.389 1.35-5.124 2.931-8.728.856-14.248Z",
        fill: "url(#Student_svg__f)",
        fillRule: "nonzero"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M41 66a163.16 163.16 0 0 1 3.524 36 15.185 15.185 0 0 0 8.415-3.58c.343.69.719 1.346 1.061 2.036",
        stroke: "#000",
        strokeWidth: 1.428
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M58.097 38.875c-2.355-.782-4.81-2.285-5.075-4.633-.232-2.066 1.393-3.85 2.886-5.384 1.592-1.627 3.184-3.224 4.777-4.852.331-.344.696-.688 1.16-.876.664-.25 1.394-.094 2.09.094 3.417.908 6.601 2.473 9.752 4.038 1.161.563 2.322 1.158 3.284 1.94 2.753 2.254 3.881 6.418 2.322 9.517-2.886-1.033-6.335.094-9.354.751-3.914.877-8.06.657-11.842-.595Z",
        fill: "#428DFC",
        fillRule: "nonzero"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M63.508 36c5.66 0 11.19-1.052 16.23-3.157.196-.07.327-.351.229-.562-.066-.21-.328-.35-.524-.245C71.525 35.298 62.33 36 53.496 34c-.23-.035-.426.106-.491.351a.465.465 0 0 0 .327.526A47.616 47.616 0 0 0 63.508 36Z",
        fill: "#E94A47",
        fillRule: "nonzero"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M71.956 36c3.152 0 6.073-.448 8.761-1.345a.417.417 0 0 0 .266-.512c-.067-.224-.299-.32-.531-.256-7.268 2.401-16.329 1.473-26.883-2.85-.199-.096-.464 0-.53.224-.1.192 0 .448.232.513C60.14 34.624 66.38 36 71.956 36Z",
        fill: "#E94A47",
        fillRule: "nonzero"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M63.344 21.374c1.687-4.14-.065-10.138-3.148-13.333-3.083-3.228-7.593-4.793-12.039-5.02-1.395-.066-2.855 0-4.088.619-1.234.652-2.24 1.988-2.045 3.39 1.688-.88 3.83-.359 5.322.848 1.46 1.206 2.369 2.966 3.05 4.76.552 1.434.974 2.933 1.947 4.107 1.071 1.337 2.661 2.087 4.219 2.804 2.012.88 4.153 2.803 6.1 1.793.13 3.358.455.684.682.032Z",
        fill: "#428DFC",
        fillRule: "nonzero"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M63.307 21c.1 0 .2-.066.2-.165.598-3.505.664-7.109.133-10.646-.499-3.373-1.429-5.753-2.99-7.538C58.656.369 55.567-.59 53.142.369c-.1.033-.167.166-.133.265.033.1.166.165.265.132 2.26-.892 5.183 0 7.043 2.182 1.495 1.72 2.392 4.034 2.89 7.307a33.81 33.81 0 0 1-.132 10.514c-.033.099.066.231.166.231h.066Z",
        fill: "#428DFC",
        fillRule: "nonzero"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M71.666 52c.9 0 1.934-.313 2.834-.87 2.068-1.29 3.035-3.483 2.201-4.946-.433-.766-1.3-1.184-2.367-1.184-.9 0-1.934.313-2.834.87-2.068 1.29-3.035 3.483-2.201 4.946.433.766 1.3 1.184 2.367 1.184Zm2.634-6.164c.767 0 1.368.278 1.668.766.6 1.01-.3 2.751-1.901 3.761-.767.488-1.634.766-2.4.766-.768 0-1.368-.278-1.668-.766-.6-1.01.3-2.751 1.9-3.761.8-.488 1.635-.766 2.401-.766Z",
        fill: "#23286B",
        fillRule: "nonzero"
      }
    ),
    /* @__PURE__ */ jsx("path", { fill: "#E94A47", fillRule: "nonzero", d: "M60 19h5v5h-5z" }),
    /* @__PURE__ */ jsx("path", { fill: "#D62929", fillRule: "nonzero", d: "M0 142h45v11H0z" }),
    /* @__PURE__ */ jsx("path", { fill: "#428DFC", fillRule: "nonzero", d: "M9 152h45v11H9z" }),
    /* @__PURE__ */ jsx("path", { fill: "#D6D7D8", fillRule: "nonzero", d: "M0 145h42v6H0z" }),
    /* @__PURE__ */ jsx("path", { fill: "#EEE", fillRule: "nonzero", d: "M25 155h16v5H25z" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M106 77.428 88.655 70S49.74 83.087 50 83.988c.26.9 10.265 10.418 11.304 10.997 1.04.61 44.695-17.557 44.695-17.557Z",
        fill: "url(#Student_svg__g)",
        fillRule: "nonzero"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M95.77 79c.068 0 .135-.035.203-.105.067-.105 0-.244-.102-.28l-10.574-5.587c-.1-.07-.236 0-.27.105-.067.105 0 .244.102.28L95.703 79c0-.035.033 0 .067 0ZM91.794 82a.19.19 0 0 0 .17-.097c.069-.097.035-.226-.068-.258L81.31 76.034c-.103-.065-.24-.033-.273.064-.069.097-.035.226.068.258l10.587 5.612c.034 0 .069.032.103.032ZM83.8 86a.182.182 0 0 0 .166-.102.225.225 0 0 0-.067-.306l-11.566-7.557c-.1-.068-.232-.034-.299.068a.225.225 0 0 0 .067.307l11.566 7.556c.067 0 .1.034.133.034ZM64.79 90a.191.191 0 0 0 .173-.097c.068-.096.034-.225-.035-.29l-9.581-6.578a.268.268 0 0 0-.31.032c-.068.097-.034.226.035.29l9.581 6.61c.07 0 .104.033.138.033ZM71.8 87a.181.181 0 0 0 .165-.107.241.241 0 0 0-.066-.32l-9.566-6.536c-.1-.071-.232-.036-.298.071a.241.241 0 0 0 .066.32l9.566 6.536c.066.036.1.036.132.036Z",
        fill: "#23286B",
        fillRule: "nonzero"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M67.762 75.08c1.163.282 4.231 1.27 5.458 1.976 1.098.635 2.713 1.764 2.778 3.14.096 1.8-2.68.106-4.199-.53-2.906-1.199-6.297-1.622-10.85-.81-1.034.176-2.39-.495-1.81-.918.614-.388 1.034-.953 2.197-1.588 1.388-.74 4.876-1.623 6.426-1.27Z",
        fill: "#FFBEB6",
        fillRule: "nonzero"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M53 94.792c3.725 0 16.187-2.456 22.846-5.39 1.813-.797 6.132-5.836 7.055-6.315 2.934-1.53 8.308-3.444 8.506-3.03 2.044 3.285-3.627 2.329-6.1 5.39 4.55-1.562 8.144-3.125 12.693-4.688-.527 4.21-3.692 3.03-5.242 5.199-.296.414-2.604 7.463-3.099 7.718-.593.319-1.285.223-1.945.16a53.597 53.597 0 0 0-10.846.063c-2.308.255-16.516 7.559-18.791 8.101-.099-1.403-4.582-5.932-5.077-7.208Z",
        fill: "url(#Student_svg__h)",
        fillRule: "nonzero"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M37.246 51.987c1.154-2.862 5.21-5.593 8.243-4.87 3.297.79 3.627 4.87 3.594 8.226-.066 5.757-.528 13.291-.824 17.47-.43 6.185.857 12.304 2.044 18.39.198 1.12.593 2.074 1.12 2.863 8.474.46 17.08-1.283 24.695-5.066 1.682 2.697 2.671 5.856 2.869 9.047.033.658.033 1.349-.363 1.875-.428.593-1.187.823-1.88 1.02-11.077 2.994-20.737 5.166-32.145 6.054-.33.033-.66-.132-.923-.46a1.188 1.188 0 0 1-.495-.494c-2.539-4.837-4.187-11.746-5.308-17.8-1.22-6.612-1.748-12.666-2.572-19.344-.725-5.462-.165-11.713 1.945-16.91Z",
        fill: "#A1C3FC",
        fillRule: "nonzero"
      }
    ),
    /* @__PURE__ */ jsx("path", { fill: "#EEE", fillRule: "nonzero", d: "M0 148h42v1H0z" }),
    /* @__PURE__ */ jsx("path", { fill: "#EEE", fillRule: "nonzero", d: "M0 148h42v1H0zM0 146h42v1H0zM0 144h42v1H0z" }),
    /* @__PURE__ */ jsx("circle", { fill: "#23286B", fillRule: "nonzero", cx: 17, cy: 158, r: 3 }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M46.777 58.046c-.07-.065-.07-.098 0-.163.068-.065.103-.065.171 0 .07.065.07.098 0 .163-.068.032-.103 0-.171 0Zm-3.61-10.565c-.068 0-.103-.032-.103-.097s.035-.098.103-.098c.07 0 .104.033.104.098.068.097-.07.162-.104.097Zm2.2 5.234c-.068 0-.103 0-.172-.033 0-.065 0-.097.035-.162.069 0 .103 0 .172.032.068.098 0 .163-.035.163ZM33.303 61.49c-.103.065-.207 0-.275-.097-.07-.098 0-.195.103-.26s.206 0 .275.097c.103.098 0 .26-.103.26Zm4.915-1.852c-.103.065-.206 0-.275-.098-.069-.097 0-.195.103-.26s.206 0 .275.098c.034.097 0 .227-.103.26Zm4.915-1.886c-.103.065-.206 0-.275-.097-.069-.098 0-.195.103-.26s.206 0 .275.097c.035.098 0 .195-.103.26ZM41.346 69c-.069-.097-.069-.195 0-.325.103-.065.206-.065.343 0 .07.098.07.195 0 .26-.103.163-.24.163-.343.065Zm3.78-3.478c-.068-.097-.068-.195 0-.325.104-.065.207-.065.344 0 .07.098.07.195 0 .26-.103.13-.275.13-.343.065ZM33.75 51.447c-.103 0-.24-.098-.24-.195 0-.098.103-.228.206-.228s.24.098.24.195c0 .098-.102.196-.206.228Zm5.294 0c-.103 0-.24-.098-.24-.195 0-.098.102-.228.205-.228.104 0 .241.098.241.195.034.13-.103.228-.206.228Zm5.259.033c-.103 0-.24-.098-.24-.196 0-.097.102-.227.205-.227.104 0 .241.097.241.195.034.163-.103.228-.206.228Zm.756 20.901c-.069-.065-.103-.195 0-.26.069-.065.206-.098.275 0 .069.065.103.195 0 .26-.034.098-.138.098-.275 0Zm-9.006-16.578c-.103 0-.206-.033-.24-.163 0-.097.034-.162.172-.227.103 0 .206.032.24.162 0 .13-.034.228-.172.228Zm4.71-.39c-.104 0-.207-.033-.241-.163 0-.097.034-.162.172-.227.103 0 .206.032.24.162 0 .13-.068.228-.172.228Zm4.674-.423c-.103 0-.206-.032-.24-.162 0-.098.034-.163.171-.228.103 0 .207.033.24.163 0 .195-.068.227-.17.227Zm-4.228 9.264c-.103.065-.206 0-.275-.097-.068-.098 0-.195.103-.26.104-.065.207 0 .275.097.07.098 0 .26-.103.26Zm4.194-2.015c-.103.065-.207 0-.275-.032-.069-.098 0-.195.103-.26s.206 0 .275.097c.034.033 0 .13-.103.195Zm-6.084-14.92c-.103-.033-.172-.098-.103-.195.034-.098.172-.163.206-.098.103.033.172.163.137.26 0-.032-.103.033-.24.033Zm4.503 1.3c-.104-.033-.172-.163-.138-.26.034-.098.172-.163.275-.13.103.032.172.162.103.195-.034.195-.137.26-.24.195.034 0 0 0 0 0Zm-3.438 25.355c-.103.065-.206 0-.275-.098-.068-.097 0-.195.103-.26.104-.065.207 0 .275.098.035.097 0 .195-.103.26Zm4.812-2.308c-.103.065-.206 0-.275-.098-.068-.097 0-.195.104-.26.103-.065.206 0 .275.098.068.032.034.195-.104.26Zm-6.84-19.309c-.103-.032-.171-.162-.137-.26.034-.097.172-.162.275-.13.103.033.172.163.137.26 0 .13-.137.195-.275.13Zm5.225 1.626c-.103-.033-.172-.163-.138-.26.035-.098.172-.163.275-.13.104.032.172.162.138.26-.069.064-.172.162-.275.13Zm-3.884 9.556c-.103 0-.24-.097-.24-.195 0-.097.102-.227.206-.227.103 0 .24.097.24.195 0 .097-.103.195-.206.227Zm5.396-.422c-.103 0-.24-.098-.24-.195 0-.098.103-.228.206-.228s.24.098.24.195c0 .13-.034.228-.206.228Zm-6.05 3.868c-.102 0-.24-.098-.24-.195 0-.098.103-.228.206-.228.104 0 .207.033.241.195.034.13-.103.228-.206.228Zm5.397-.585c-.103 0-.24-.098-.24-.195 0-.098.034-.195.206-.228a.34.34 0 0 1 .275.195c0 .098-.103.228-.24.228Zm-1.856-9.557c-.103-.032-.172-.162-.172-.26.035-.098.172-.163.275-.163.103.033.172.163.172.26 0 .098-.172.13-.275.163Z",
        fill: "#FFF",
        fillRule: "nonzero"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M50.944 39c-.822 2.407 1.987 10.078 2.055 10.367.069.256-3.905 8.633-3.905 8.633s-1.61-4.814-2.089-7.253c-.617-2.953-1.678-6.387-.411-9.147 0-.16 3.87-2.247 4.35-2.6Z",
        fill: "#428DFC",
        fillRule: "nonzero"
      }
    )
  ] })
] });
const ForwardRef = forwardRef(SvgStudent);
export {
  ForwardRef as default
};
